import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { ChangeDetectorRef, Component, EventEmitter, HostBinding, HostListener, Inject, Input, OnInit, Output, PLATFORM_ID, ViewChild, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { fromEvent } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  pairwise,
  share,
  take,
  throttleTime
} from 'rxjs/operators';
import { SwPush } from '@angular/service-worker';
import { NotificationService } from 'src/app/services/notifications.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { I18nService } from 'src/app/services/i18n.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ACCOUNT_SECTIONS } from '../../my-account/account-sections';
import { categoryEnum, pathRoutingEnum } from 'src/assets/constantEnum';
import { MatAccordion } from '@angular/material/expansion';
import { DeviceDetectorService } from 'ngx-device-detector';

import { TypeProductService } from 'src/app/services/type-product.service';
import { BrandProductService } from 'src/app/services/brand-product.service';
import { ReferenceProductService } from 'src/app/services/reference-product.service';
import { Title, Meta } from '@angular/platform-browser';
import { CanonicalService } from 'src/app/services/canonical.service';
import { CookieService } from 'src/app/services/cookie.service';
import { Store } from '@ngrx/store';
import { SearchProductsAction } from 'src/app/ngrx/products.action';
import { ProductsState } from 'src/app/ngrx/products.reducer';
import { SearchProductDto } from '../../../models/search-product-dto';
import { TypeProduct } from 'src/app/models/type-product';
import { BrandProduct } from 'src/app/models/brand-product';
import { ReferenceProduct } from 'src/app/models/reference-product';
import { Platform } from '@angular/cdk/platform';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { DialogContentNewsLetter } from '../../newsletter-dialog/dialog-content-newsletter';
import { DialogContentLogin } from '../login-dialog/dialog-content-login';
import { AuthService } from 'src/app/services/auth.service';
import { AdvertiserActionsTypesNgrx } from 'src/app/ngrx/advertiser/advertisers.action';
import { AdvertiserService } from 'src/app/services/advertiser.service';


enum VisibilityState {
  Visible = 'visible',
  Hidden = 'hidden'
}

enum Direction {
  Up = 'Up',
  Down = 'Down'
}

// @Component({
//   selector: 'app-header-sticky',
//   templateUrl: './header-sticky.component.html',
//   styleUrls: ['./header-sticky.component.scss']
// })

export interface DialogData {
  acceptNewsLetter: boolean;
  email: any;
}


@Component({
    selector: 'app-header-sticky-front-office',
    templateUrl: './header-sticky-front-office.component.html',
    styleUrls: ['./header-sticky-front-office.component.scss'],
    /*styles: [
      `
        :host {
          position: fixed;
          top: 0;
          width: 100%;
        }
      `
    ],*/
    animations: [
        trigger('toggle', [
            state(VisibilityState.Hidden, style({ opacity: 0, transform: 'translateY(-100%)' })),
            state(VisibilityState.Visible, style({ opacity: 1, transform: 'translateY(0)' })),
            transition('* => *', animate('200ms ease-in'))
        ])
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class HeaderStickyFrontOfficeComponent implements OnInit {

  readonly accountSections = ACCOUNT_SECTIONS;

  static readonly DEFAULT_AVATAR = 'assets/userAvatar.svg';
  userAvatar = HeaderStickyFrontOfficeComponent.DEFAULT_AVATAR;
  userHasAvatar = false;
  userInitial = '';
  search: String = "";
  public constantEnum: typeof categoryEnum = categoryEnum
  indexTabChangeEvent: any;
  mobile: boolean = false;
  diplaySearchMobile: boolean = false;
  products!: any;
  searchProducts!: SearchProductDto[];
  searchProductDto!: SearchProductDto;
  deviceInfo!: any;
  isMobile: boolean = false;
  isTablet: boolean = false;
  isDesktopDevice: boolean = false;
  isDisplaySearch: boolean = false;
  mobileTab: 'deals' | 'codes' | 'categories' | null = null;
  limit: number = 10;
  skip: number = 0;
  state: ProductsState | null = null;
  acceptNewsLetter: boolean = false;
  email!: string;

  @Input('inputRole')
  inputRole !: any;

  @Output("outputRoleToParent") outputRoleToParent: EventEmitter<any> = new EventEmitter();
  @ViewChild(MatAccordion) accordion!: MatAccordion;
  isOpenNavbar: boolean = false;
  cookiesNewsletter!: string | null;
  cookies_login!: string | null;
  boolnavCategories: boolean = false;
  // Catégorie active de la barre desktop (tirée de l'URL), pour ne surligner que la puce sélectionnée
  selectedCategoryKey: string | null = null;

  isLoggedIn = false; // Définit l'état de connexion

  pushSupported: boolean = false;
  isSubscribedToPush: boolean = false;
  notificationsBusy: boolean = false;
  settings: any;

  private static readonly TOP_BANNER_DISMISSED_KEY = 'top_banner_dismissed';

  private static readonly PUSH_OPT_OUT_KEY = 'pushOptOut';

  private static readonly PUSH_PROMPT_KEY = 'pushPromptAt';

  private static readonly PUSH_PROMPT_INTERVAL = 7 * 24 * 60 * 60 * 1000;
  // Bannière « Ajouter à Chrome » : affichée seulement côté navigateur, si l'extension est publiée
  // (environment.chromeExtensionUrl) et que le navigateur peut l'installer (Chromium : Chrome, Edge, Brave, Opera…)
  showTopBanner: boolean = false;
  readonly chromeExtensionUrl: string = environment.chromeExtensionUrl;

  constructor(
    private store: Store<any>,

    private router: Router,
    private activatedRoute: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
    private deviceService: DeviceDetectorService,
    private typeProductService: TypeProductService,
    private brandProductService: BrandProductService,
    private referenceProductService: ReferenceProductService,
    private advertiserService: AdvertiserService,
    public cookie: CookieService,
    private title: Title,
    private metaTagService: Meta,
    private canonicalService: CanonicalService,
    @Inject(DOCUMENT) private document: Document,
    private platform: Platform,
    private authService: AuthService,
    private cdRef: ChangeDetectorRef,
    private pushService: SwPush,
    private notificationService: NotificationService,
    private snackBar: MatSnackBar,
    private i18n: I18nService,
    @Inject(PLATFORM_ID) private platformId: Object,
    public dialog: MatDialog) {
    this.epicFunction();
  }

  ngOnInit(): void {
    this.updateSelectedCategoryKey(this.router.url);
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      this.updateSelectedCategoryKey((event as NavigationEnd).urlAfterRedirects);
    });

     // Abonnement à l'état de connexion pour être mis à jour en temps réel
     this.authService.currentUser$.subscribe((user) => {
      this.isLoggedIn = !!user;
      this.userHasAvatar = !!user?.avatar;
      this.userAvatar = user?.avatar || HeaderStickyFrontOfficeComponent.DEFAULT_AVATAR;
      this.userInitial = (user?.pseudo || user?.name || '').trim().charAt(0).toUpperCase();
      if (isPlatformBrowser(this.platformId)) {
        this.cdRef.detectChanges(); // 🔥 Forcer Angular à rafraîchir la vue
      }
    });

    if (!isPlatformBrowser(this.platformId)) {
      // Le reste de ngOnInit dépend d'API navigateur (localStorage, matchMedia, service worker)
      // indisponibles côté serveur (SSR).
      return;
    }

    this.breakpointObserver
      .observe(['(min-width: 992px)'])
      .subscribe((state: BreakpointState) => {

        if (state.matches) {
          this.mobile = false;

        } else {
          this.mobile = true;
        }
      });
    // this.store.subscribe(myStore => {
    //   this.state = myStore.ProductsStateFromModule;
    // });
    this.cookiesNewsletter = localStorage.getItem('cookies_newsletter');
    if (this.cookiesNewsletter == null || this.cookiesNewsletter === "") {
      this.cookiesNewsletter = "2";
      this.setConsent("2");
    }

    this.cookies_login = localStorage.getItem('cookies_login');
    if (this.cookies_login == null || this.cookies_login === "") {
      this.cookies_login = "0";
      this.setConsent("0");
    }

    this.showTopBanner = !!this.chromeExtensionUrl
      && this.isChromiumBrowser()
      && localStorage.getItem(HeaderStickyFrontOfficeComponent.TOP_BANNER_DISMISSED_KEY) !== '1';

    this.pushSupported = this.pushService.isEnabled;
    if (this.pushSupported) {
      this.store.subscribe(myStore => {
        this.settings = myStore.SettingsStateFromModule?.settings;
      });
      this.pushService.subscription.subscribe(sub => {
        this.isSubscribedToPush = !!sub;
      });
      this.syncPushSubscription();
    }

  }

  // Au démarrage : renvoie l'abonnement existant à l'API (au cas où il aurait été purgé),
  // et le recrée s'il a été fait avec d'anciennes clés VAPID (régénérées dans le back office),
  // sinon le navigateur reste "abonné" mais ne reçoit plus aucune notification.
  private syncPushSubscription(): void {
    this.store.select(state => state.SettingsStateFromModule?.settings?.[0]?.publicKeyNotification)
      .pipe(filter(key => !!key), take(1))
      .subscribe((serverPublicKey: string) => {
        this.pushService.subscription.pipe(take(1)).subscribe(sub => {
          if (!sub) {
            this.autoSubscribeOrPrompt(serverPublicKey);
            return;
          }
          if (this.isSameVapidKey(sub, serverPublicKey)) {
            this.notificationService.addSubscription(sub).catch(err => console.error('Could not sync push subscription:', err));
            return;
          }
          const oldEndpoint = sub.endpoint;
          this.pushService.unsubscribe()
            .then(() => this.notificationService.removeSubscription(oldEndpoint))
            .then(() => this.pushService.requestSubscription({ serverPublicKey }))
            .then(newSub => this.notificationService.addSubscription(newSub))
            .catch(err => console.error('Could not renew push subscription:', err));
        });
      });
  }

  // Aucun compte n'est nécessaire : c'est l'appareil qui s'abonne. Le navigateur exige seulement
  // que la personne ait autorisé les notifications une fois.
  private autoSubscribeOrPrompt(serverPublicKey: string): void {
    if (typeof Notification === 'undefined' || this.readStorage(HeaderStickyFrontOfficeComponent.PUSH_OPT_OUT_KEY) === '1') {
      return;
    }
    // Déjà autorisé (ex. application installée) : abonnement silencieux, sans passer par la cloche
    if (Notification.permission === 'granted') {
      this.pushService.requestSubscription({ serverPublicKey })
        .then(sub => this.notificationService.addSubscription(sub))
        .catch(err => console.error('Could not auto-subscribe to push:', err));
      return;
    }
    // Jamais demandé : on propose l'activation après quelques secondes, puis au plus une fois par semaine
    const lastPrompt = Number(this.readStorage(HeaderStickyFrontOfficeComponent.PUSH_PROMPT_KEY)) || 0;
    if (Notification.permission === 'default' && Date.now() - lastPrompt > HeaderStickyFrontOfficeComponent.PUSH_PROMPT_INTERVAL) {
      setTimeout(() => {
        if (this.isSubscribedToPush) {
          return;
        }
        this.writeStorage(HeaderStickyFrontOfficeComponent.PUSH_PROMPT_KEY, String(Date.now()));
        this.snackBar.open(this.i18n.t('header.pushPrompt'), this.i18n.t('header.pushPromptAction'), {
          duration: 15000,
          verticalPosition: 'top',
        }).onAction().subscribe(() => this.toggleNotifications());
      }, 8000);
    }
  }

  private readStorage(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  private writeStorage(key: string, value: string | null): void {
    try {
      value === null ? localStorage.removeItem(key) : localStorage.setItem(key, value);
    } catch {
      // stockage indisponible (navigation privée)
    }
  }

  private isSameVapidKey(sub: PushSubscription, serverPublicKey: string): boolean {
    const key = sub.options?.applicationServerKey;
    if (!key) {
      return true;
    }
    let binary = '';
    new Uint8Array(key).forEach(b => binary += String.fromCharCode(b));
    const subKey = btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return subKey === serverPublicKey.replace(/=+$/, '');
  }

  toggleNotifications(): void {
    if (!this.pushSupported || this.notificationsBusy) {
      return;
    }

    if (this.isSubscribedToPush) {
      this.notificationsBusy = true;
      this.pushService.subscription.pipe(take(1)).subscribe(sub => {
        const endpoint = sub?.endpoint;
        this.pushService.unsubscribe()
          .then(() => endpoint && this.notificationService.removeSubscription(endpoint))
          .then(() => {
            // Choix explicite : ne plus réabonner automatiquement cet appareil
            this.writeStorage(HeaderStickyFrontOfficeComponent.PUSH_OPT_OUT_KEY, '1');
            this.showPushMessage('header.pushDisabled');
          })
          .catch(err => console.error('Could not unsubscribe due to:', err))
          .finally(() => this.notificationsBusy = false);
      });
      return;
    }

    // Permission déjà refusée : le navigateur ne redemandera pas, il faut l'autoriser à la main
    if (typeof Notification !== 'undefined' && Notification.permission === 'denied') {
      this.showPushMessage('header.pushDenied');
      return;
    }

    if (!this.settings || this.settings.length === 0 || !this.settings[0].publicKeyNotification) {
      this.showPushMessage('header.pushUnavailable');
      return;
    }

    this.notificationsBusy = true;
    this.pushService.requestSubscription({ serverPublicKey: this.settings[0].publicKeyNotification })
      .then(sub => this.notificationService.addSubscription(sub))
      .then(() => {
        this.writeStorage(HeaderStickyFrontOfficeComponent.PUSH_OPT_OUT_KEY, null);
        this.showPushMessage('header.pushEnabled');
      })
      .catch(err => {
        console.error('Could not subscribe due to:', err);
        const denied = typeof Notification !== 'undefined' && Notification.permission === 'denied';
        this.showPushMessage(denied ? 'header.pushDenied' : 'header.pushError');
      })
      .finally(() => this.notificationsBusy = false);
  }

  private showPushMessage(key: string): void {
    this.snackBar.open(this.i18n.t(key), this.i18n.t('common.ok'), { duration: 6000 });
  }

  getBoolean(value: any) {
    switch (value) {
      case true:
      case "true":
      case 1:
      case "1":
      case "on":
      case "yes":
        return true;
      default:
        return false;
    }
  }

  ngAfterViewInit(): void {
    if (this.isMobile == true || this.isTablet) {
      // document.getElementsByClassName('mat-tab-header-pagination-before')[0].remove();
      // document.getElementsByClassName('mat-tab-header-pagination-after')[0].remove();
      const linkContainer = document.querySelector<HTMLElement>(".mat-mdc-tab-link-container");
      if (linkContainer) {
        linkContainer.style.overflow = 'scroll';
      }
    }
  }

  epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }

  opened: boolean = false;
  toggleMenu() {

    this.opened = !this.opened;
  }

  onSearchAutoComplete(dataForm: any) {
    this.searchProducts = [];
    if (dataForm.searchKeyWords && dataForm.searchKeyWords.length > 2) {
      this.typeProductService.searchTypeProduct(dataForm.searchKeyWords).subscribe(searchTypeProducts => {
        for (let i = 0; i < searchTypeProducts.length; i++) {
          this.searchProductDto = {
            _id: searchTypeProducts[i]._id,
            searchProduct: searchTypeProducts[i].type,
            description: searchTypeProducts[i].description,
            pictureUrl: searchTypeProducts[i].pictureUrl,
          }

          this.searchProducts.push(this.searchProductDto);
        }
      });
      this.brandProductService.searchBrandProduct(dataForm.searchKeyWords).subscribe(searchBrandProducts => {
        for (let i = 0; i < searchBrandProducts.length; i++) {
          this.searchProductDto = {
            _id: searchBrandProducts[i]._id,
            searchProduct: searchBrandProducts[i].brand,
            description: searchBrandProducts[i].description,
            pictureUrl: searchBrandProducts[i].pictureUrl,
          }
          this.searchProducts.push(this.searchProductDto);
        }
      });
      this.referenceProductService.searchReferenceProduct(dataForm.searchKeyWords).subscribe(searchReferenceProducts => {
        for (let i = 0; i < searchReferenceProducts.length; i++) {
          this.searchProductDto = {
            _id: searchReferenceProducts[i]._id,
            searchProduct: searchReferenceProducts[i].reference,
            description: searchReferenceProducts[i].description,
            pictureUrl: searchReferenceProducts[i].pictureUrl,
          }
          this.searchProducts.push(this.searchProductDto);
        }
      });
      this.advertiserService.searchAdvertisers(dataForm.searchKeyWords).subscribe(searchReferenceProducts => {
        for (let i = 0; i < searchReferenceProducts.length; i++) {
          this.searchProductDto = {
            _id: searchReferenceProducts[i]._id,
            searchProduct: searchReferenceProducts[i].advertiserName,
            description: searchReferenceProducts[i].name,
            pictureUrl: searchReferenceProducts[i].pictureUrl,
          }
          this.searchProducts.push(this.searchProductDto);
        }
      });
      // this.isOpenNavbar = false;
      // if(this.mobile && !this.isMobile && !this.isTablet) {
      //   this.accordion.closeAll();
      // }
    }
  }

  onSearch(dataForm: any) {
    setTimeout(async () => {
      this.searchProducts = [];
      let data = {
        limit: this.limit,
        skip: this.skip
      }
      // this.productService.searchProducts (dataForm.searchKeyWords, data ).subscribe (products => {
      //   //this.products = products
      //       //this.dashboardComponent.products = products;
      // });
      //this.dashboardComponent.onSearch(dataForm.searchKeyWords);
      let searchKeyWords = dataForm.searchKeyWords;
      this.store.dispatch(new SearchProductsAction({ searchKeyWords, data }));
      this.store.subscribe((myStore) => {
        if (myStore.ProductsStateFromModule) {
          this.state = myStore.ProductsStateFromModule;
          this.products = this.state?.products;

        }
      });
      // this.isOpenNavbar = false;
      // if(this.mobile && !this.isMobile && !this.isTablet) {
      //   this.accordion.closeAll();
      // }
    }, 1000);
  }

  onClickToSearch() {
    this.router.navigate([pathRoutingEnum.dashboard.valueOf()]);
  }

  onDashboard() {
    this.boolnavCategories = false;
    this.search = "";
    if (this.router.url === pathRoutingEnum.dashboard.valueOf()) {
      this.router.navigate([pathRoutingEnum.promotion.valueOf()]);
    } else {
      this.router.navigate([pathRoutingEnum.dashboard.valueOf()]);
    }

  }

  onFilterCategory(dataForm: any) {
    this.boolnavCategories = false;
    this.selectedCategoryKey = dataForm;
    this.redirectTo(pathRoutingEnum.category.valueOf() + '/' + dataForm)
  }

  private updateSelectedCategoryKey(url: string): void {
    const prefix = '/' + pathRoutingEnum.category.valueOf() + '/';
    this.selectedCategoryKey = url.startsWith(prefix) ? url.slice(prefix.length).split(/[/?#]/)[0] : null;
    this.mobileTab = this.mobileTabOf(url.split(/[?#]/)[0]);
  }

  // Onglet surligné dans l'en-tête mobile (« Près de moi » est dans les raccourcis et la barre du bas)
  private mobileTabOf(path: string): 'deals' | 'codes' | 'categories' | null {
    if (path === pathRoutingEnum.dashboard.valueOf() || path === pathRoutingEnum.promotion.valueOf()) {
      return 'deals';
    }
    if (path === pathRoutingEnum.promotionCode.valueOf()) {
      return 'codes';
    }
    if (path.startsWith('/' + pathRoutingEnum.category.valueOf() + '/') || path === '/' + pathRoutingEnum.menuMobile.valueOf()) {
      return 'categories';
    }
    return null;
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }

  diplayNavCategories() {
    this.boolnavCategories = !this.boolnavCategories;
  }

  OpenMenuMobile() {
    this.redirectTo(pathRoutingEnum.menuMobile.valueOf())
  }

  // tabChanged(tabChangeEvent: MatTabChangeEvent): void {
  //   this.indexTabChangeEvent = tabChangeEvent.index;
  //   if (tabChangeEvent.index === 0) {
  //     this.onDashboard();
  //   } else if (tabChangeEvent.index === 1) {
  //     this.onFilterCategory(categoryEnum.electro);
  //   } else if (tabChangeEvent.index === 2) {
  //     this.onFilterCategory(categoryEnum.videoGame);
  //   } else if (tabChangeEvent.index === 3) {
  //     this.onFilterCategory(categoryEnum.fashion);
  //   } else if (tabChangeEvent.index === 4) {
  //     this.onFilterCategory(categoryEnum.cosmetic);
  //   } else if (tabChangeEvent.index === 5) {
  //     this.onFilterCategory(categoryEnum.sport);
  //   } else if (tabChangeEvent.index === 6) {
  //     this.onFilterCategory(categoryEnum.family);
  //   } else if (tabChangeEvent.index === 7) {
  //     this.onFilterCategory(categoryEnum.home);
  //   } else if (tabChangeEvent.index === 8) {
  //     this.onFilterCategory(categoryEnum.trip);
  //   } else if (tabChangeEvent.index === 9) {
  //     this.onFilterCategory(categoryEnum.mechanic);
  //   } else if (tabChangeEvent.index === 10) {
  //     this.onFilterCategory(categoryEnum.gardenDIY);
  //   } else if (tabChangeEvent.index === 11) {
  //     this.onFilterCategory(categoryEnum.service);
  //   } else if (tabChangeEvent.index === 12) {
  //     this.onFilterCategory(categoryEnum.featuredBrand);
  //   } else if (tabChangeEvent.index === 13) {
  //     this.onFilterCategory(categoryEnum.training);
  //   } else if (tabChangeEvent.index === 14) {
  //     this.onFilterCategory(categoryEnum.deal);
  //   } else if (tabChangeEvent.index === 15) {
  //     this.onFilterCategory(categoryEnum.finance);
  //   } else if (tabChangeEvent.index === 16) {
  //     this.onFilterCategory(categoryEnum.grocery);
  //   } else if (tabChangeEvent.index === 17) {
  //     this.onFilterCategory(categoryEnum.crypto);
  //   } else if (tabChangeEvent.index === 18) {
  //     this.onFilterCategory(categoryEnum.free);
  //   }
  //   // this.isOpenNavbar = false;
  //   // if(this.mobile && !this.isMobile && !this.isTablet) {
  //   //   this.accordion.closeAll();
  //   // }
  //   this.search = "";
  // }

  onFilterByPromotionCode() {
    this.boolnavCategories = false;
    this.redirectTo(pathRoutingEnum.promotionCode.valueOf());
    this.search = "";
  }

  private isVisible = true;

  @HostBinding('@toggle')
  get toggle(): VisibilityState {
    return this.isVisible ? VisibilityState.Visible : VisibilityState.Hidden;
  }


  @HostListener('window:scroll')
  onScroll() {
    // this.isOpenNavbar = false;
    // if(this.mobile && !this.isMobile && !this.isTablet) {
    //   this.accordion.closeAll();
    // }

    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (scrollPosition >= 10) {
      const scroll$ = fromEvent(window, 'scroll').pipe(
        throttleTime(10),
        map(() => window.pageYOffset),
        pairwise(),
        map(([y1, y2]): Direction => (y2 < y1 ? Direction.Up : Direction.Down)),
        distinctUntilChanged(),
        share()
      );

      const scrollUp$ = scroll$.pipe(
        filter(direction => direction === Direction.Up)
      );

      const scrollDown = scroll$.pipe(
        filter(direction => direction === Direction.Down)
      );

      scrollUp$.subscribe(() => (this.isVisible = true));
      scrollDown.subscribe(() => (this.isVisible = false));
    }

    if (scrollPosition < 10 && this.platform.IOS) {
      const scroll$ = fromEvent(window, 'scroll').pipe(
        throttleTime(10),
        map(() => window.pageYOffset),
        pairwise(),
        map(([y1, y2]): Direction => (y2 < y1 ? Direction.Up : Direction.Down)),
        distinctUntilChanged(),
        share()
      );

      const scrollDown = scroll$.pipe(
        filter(direction => direction === Direction.Down)
      );

      scrollDown.subscribe(() => (this.isVisible = true));

    }

  }

  preventBehavior(e: any) {
    e.preventDefault();
  };


  // ngAfterViewInit() {
  //   const scroll$ = fromEvent(window, 'scroll').pipe(
  //     throttleTime(10),
  //     map(() => window.pageYOffset),
  //     pairwise(),
  //     map(([y1, y2]): Direction => (y2 < y1 ? Direction.Up : Direction.Down)),
  //     distinctUntilChanged(),
  //     share()
  //   );

  //   const scrollUp$ = scroll$.pipe(
  //     filter(direction => direction === Direction.Up)
  //   );

  //   const scrollDown = scroll$.pipe(
  //     filter(direction => direction === Direction.Down)
  //   );

  //   scrollUp$.subscribe(() => (this.isVisible = true));
  //   scrollDown.subscribe(() => (this.isVisible = false));
  // }

  onGoDashboard() {
    this.router.navigate([pathRoutingEnum.dashboard.valueOf()]);
  }

  public openDialogNewsLetter(): void {
    const dialogRef = this.dialog.open(DialogContentNewsLetter, {
      width: '450px',
      data: { acceptNewsLetter: this.acceptNewsLetter, email: this.email },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.acceptNewsLetter = result?.acceptNewsLetter;
      this.email = result?.email;
      if (result === false) {
        this.setConsent("0");
        this.cookiesNewsletter = "0";
      } else {
        this.setConsent("1");
        this.cookiesNewsletter = "1";
      }
    });

  }

  public openDialogLogin(): void {
    const dialogRef = this.dialog.open(DialogContentLogin, {
      width: '550px',
      data: { acceptNewsLetter: this.acceptNewsLetter, email: this.email },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.acceptNewsLetter = result?.acceptNewsLetter;
      this.email = result?.email;
      if (result === false) {
        this.setConsent("0");
        this.cookiesNewsletter = "0";
      } else {
        this.setConsent("1");
        this.cookiesNewsletter = "1";
      }
    });

  }

  public setConsent(value: any): void {
    localStorage.setItem('cookies_newsletter', value);
  }

  logout() {
    this.authService.logout();
    this.cdRef.detectChanges(); // 🔥 Forcer Angular à rafraîchir la vue
  }

  dismissTopBanner(): void {
    this.showTopBanner = false;
    localStorage.setItem(HeaderStickyFrontOfficeComponent.TOP_BANNER_DISMISSED_KEY, '1');
  }

  openChromeExtension(): void {
    if (this.chromeExtensionUrl) {
      window.open(this.chromeExtensionUrl, '_blank', 'noopener');
    }
  }

  private isChromiumBrowser(): boolean {
    const nav = navigator as Navigator & { userAgentData?: { brands: { brand: string }[] } };
    if (nav.userAgentData?.brands) {
      return nav.userAgentData.brands.some(b => b.brand === 'Chromium');
    }
    // Repli (anciens navigateurs) : Chrome/Edge/Opera exposent "Chrome/" ; Firefox et Safari non
    return /Chrome\//.test(navigator.userAgent);
  }

  // La page /poster affiche elle-même l'invitation à se connecter si besoin
  onPoster(): void {
    this.router.navigate(['/poster']);
  }
}
